import React from 'react'
import { Tile as TileClass, Events, type CustomEventPayload } from '../zaptic-tile'
import { createComponent, type EventName } from '@lit-labs/react'
import type { Id as GuideId } from '../../domain/guides/types.no-deps'

export const GuideTile = createComponent(React, 'zaptic-tile', TileClass<GuideId>, {
    onExtraAction: Events.onExtraAction as EventName<CustomEvent<CustomEventPayload<GuideId>[Events.onExtraAction]>>,
    onClickEditButton: Events.onClickEditButton as EventName<
        CustomEvent<CustomEventPayload<GuideId>[Events.onClickEditButton]>
    >,
    onClickDeleteButton: Events.onClickDeleteButton as EventName<
        CustomEvent<CustomEventPayload<GuideId>[Events.onClickDeleteButton]>
    >,
    onSelectionChange: Events.onSelectionChange as EventName<CustomEvent<CustomEventPayload[Events.onSelectionChange]>>,
})
